import "./Button.scss"
import classNames from "classnames"

export enum ButtonSize {
  SM = "sm",
  MD = "md",
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  size?: ButtonSize
}

export const Button: React.FC<ButtonProps> = ({
  text,
  size = ButtonSize.MD,
  className,
  children,
  ...rest
}) => {
  return (
    <button
      className={classNames("button", `button--${size}`, className)}
      {...rest}
    >
      {text}
    </button>
  )
}
